import { Eye, EyeClosed } from 'lucide-react';
import React, { useState } from 'react';

const FormPasswordInput = ({ label, name, value, onChange, placeholder, required, icon, error }) => {
  const [showPassword, setShowPassword] = useState(false);
  
  // Determine if there's an error: use the passed error prop or check if required and empty
  const showError = error || (required && value.trim() === '');

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div className="flex flex-col space-y-1">
      <label className="font-medium text-gray-700 flex items-center">
        {label}
        {required && (
          <span className="ml-1 text-darkred text-sm animate-pulse" title="Required">
            *
          </span>
        )}
      </label>
      <div className="relative">
        {icon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            {icon}
          </div>
        )}
        <input
          type={showPassword ? 'text' : 'password'}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`border rounded px-3 py-2 focus:outline-none focus:ring-2 w-full ${
            showError
              ? 'border-darkred focus:ring-darkred'
              : 'border-gray-300 focus:ring-primary'
          } ${icon ? 'pl-10' : ''}`}
        />
        <button
          type="button"
          onClick={togglePasswordVisibility}
          className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500 hover:text-primary"
          aria-label={showPassword ? 'Hide password' : 'Show password'}
        >
          {showPassword ? <EyeClosed /> : <Eye />}
        </button>
      </div>
      {showError && (
        <span className="text-xs text-darkred flex items-center">
          <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M18 10A8 8 0 11 2 10a8 8 0 0116 0zm-7-4a1 1 0 10-2 0v3a1 1 0 002 0V6zm-1 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
              clipRule="evenodd"
            />
          </svg>
          {error || 'This field is required'}
        </span>
      )}
    </div>
  );
};

export default FormPasswordInput;